import { IconProps } from "typing";
import { theme } from "../themes";

export const WeddingRingIcon = ({
  width = "20",
  height = "20",
  color = theme.colors.neutral["999"],
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.1576 9.6758C17.9475 11.4657 17.9475 14.3677 16.1576 16.1576C14.3677 17.9475 11.4657 17.9475 9.6758 16.1576C7.8859 14.3677 7.8859 11.4657 9.6758 9.6758C11.4657 7.8859 14.3677 7.8859 16.1576 9.6758"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3242 9.6758C12.1141 11.4657 12.1141 14.3677 10.3242 16.1576C8.53433 17.9475 5.63233 17.9475 3.84243 16.1576C2.05252 14.3677 2.05252 11.4657 3.84243 9.6758C5.63233 7.8859 8.53433 7.8859 10.3242 9.6758"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 3.07252C12.5 3.43752 12.3425 3.78835 12.0617 4.05002L10.2192 5.77002C10.0958 5.88502 9.90417 5.88502 9.78 5.77002L7.93833 4.05085C7.6575 3.78835 7.5 3.43752 7.5 3.07252V3.07252C7.5 2.29585 8.12917 1.66669 8.90583 1.66669H11.0942C11.8708 1.66669 12.5 2.29585 12.5 3.07252V3.07252V3.07252Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
